import $ from 'jquery'
export const GNAV = {
  init: function (GLOBALSITE) {
    const $body = $('body')
    const $elm = $('.js-gnav-switch')
    const $dropdown = $('.menu-item-has-children')
    const openClass = 'is-gnav-open'
    const activeClass = 'is-active'
    const currentClass = 'is-current'
    const duration = 300

    if (!$elm.length) {
      return
    }

    $body.append('<div class="l-overlay js-overlay"></div>')

    this.setupDropdown($dropdown, activeClass, duration, GLOBALSITE)
    this.setupGnavSwitch($elm, $body, openClass, GLOBALSITE)
    this.setupOverlay($body, openClass, GLOBALSITE)
    this.applyCurrentStyles(currentClass, GLOBALSITE)
  },
  setupDropdown: function ($dropdown, activeClass, duration, GLOBALSITE) {
    if (GLOBALSITE.COMMON.VARIABLES.range_sp) {
      $dropdown.children('a').on('click', function (e) {
        e.preventDefault()
        const $parent = $(this).parent()
        $parent.toggleClass(activeClass)
        $(this).next('.sub-menu').slideToggle(duration)
      })
    } else {
      $dropdown.hover(
        function () {
          $(this).addClass(activeClass)
        },
        function () {
          $(this).removeClass(activeClass)
        },
      )
    }
  },
  setupGnavSwitch: function ($elm, $body, openClass, GLOBALSITE) {
    $elm.on('click', function (e) {
      e.preventDefault()
      // const winH = window.innerHeight
      // const headerH = $('.l-header').height()
      // $('.l-header__nav').css('height', GLOBALSITE.COMMON.VARIABLES.range_sp ? winH - headerH : '')
      $body.toggleClass(openClass)
    })
  },
  setupOverlay: function ($body, openClass, GLOBALSITE) {
    $('.js-overlay').on('click', function () {
      $body.removeClass(openClass)
    })
  },
  applyCurrentStyles: function (currentClass, GLOBALSITE) {
    $('.l-header__menu').find('[class*="current"] a').addClass(currentClass)
  },
}
